import { useTheme } from "@mui/material";
import BarometerSvg from "../assets/wmsIcon/BarometerSvg";
import CO2 from "../assets/wmsIcon/CO2";
import Discharge from "../assets/wmsIcon/Discharge";
import Evaporation from "../assets/wmsIcon/Evaporation";
import Humidity from "../assets/wmsIcon/Humidity";
import PM10 from "../assets/wmsIcon/PM10";
import PM25 from "../assets/wmsIcon/PM25";
import Rain from "../assets/wmsIcon/Rain";
import SunSvg from "../assets/wmsIcon/SunSvg";
import TVOS from "../assets/wmsIcon/TVOS";
import ThermometerSvg from "../assets/wmsIcon/ThermometerSvg";
import Wind from "../assets/wmsIcon/Wind";
import WindSpeed from "../assets/wmsIcon/WindSpeed";
export function Constants() {
    const { palette } = useTheme()
    return {
        "Barometric Pressure": <BarometerSvg width={70} height={70} svgColor={palette.primary.main} />,
        "Ambient Temperature": <ThermometerSvg width={70} height={70} color={palette.primary.main} />,
        "Evaporation": <Evaporation width={70} height={70} color={palette.primary.main} />,
        "Global Horizontal Irradiance": <SunSvg width={70} height={70} color={palette.primary.main} />,
        "Humidity": <Humidity width={70} height={70} color={palette.primary.main} />,
        "Solar Insolation": <SunSvg width={70} height={70} color={palette.primary.main} />,
        "Module Temperature": <ThermometerSvg width={70} height={70} color={palette.primary.main} />,
        "PM 1.0": <PM10 width={70} height={70} color={palette.primary.main} />,
        "PM 10": <PM10 width={70} height={70} color={palette.primary.main} />,
        "PM 2.5": <PM25 width={70} height={70} color={palette.primary.main} />,
        "RAIN": <Rain width={70} height={70} color={palette.primary.main} />,
        "Wind Direction": <Wind width={70} height={70} color={palette.primary.main} />,
        "Wind Speed": <WindSpeed width={70} height={70} color={palette.primary.main} />,
        "Multiple Module Temperature": <ThermometerSvg width={70} height={70} color={palette.primary.main} />,
        "Solar Irradiation": <SunSvg width={70} height={70} color={palette.primary.main} />,
        "Direct Solar Radiation": <SunSvg width={70} height={70} color={palette.primary.main} />,
        "TVOC": <TVOS width={70} height={70} color={palette.primary.main} />,
        "Discharge": <Discharge width={70} height={70} color={palette.primary.main} />,
        "CO2": <CO2 width={70} height={70} color={palette.primary.main} />
    }
}

